export default {"loaderContainer":"uJ9T1","content":"_6N-Zr","text":"q0-TM"};